import { BaseResourceService } from '../client/base-resource-service.js';
import { API_ENDPOINTS } from '../config/api-config.js';

/**
 * Organizations Service (Public Routes Only)
 * Handles public organization-related API endpoints
 */
export class OrganizationsService extends BaseResourceService {
  constructor(httpClient) {
    super(httpClient, API_ENDPOINTS.ORGANIZATIONS);
  }

  /**
   * Get all organizations (PUBLIC)
   */
  async getAll(params = {}) {
    return this.client.get(this.path, params);
  }

  /**
   * Get organization by ID (PUBLIC)
   */
  async getById(id) {
    return this.client.get(`${this.path}/${id}`);
  }

  /**
   * Get current organization (PUBLIC)
   */
  async getCurrent() {
    return this.client.get(API_ENDPOINTS.ORGANIZATIONS_CURRENT);
  }

  /**
   * Get organization by subdomain (PUBLIC)
   */
  async getBySubdomain(subdomain) {
    return this.client.get(`${API_ENDPOINTS.ORGANIZATIONS_SUBDOMAIN}/${subdomain}`);
  }

  /**
   * Get organization branding information (PUBLIC)
   */
  async getBranding(subdomain) {
    return this.client.get(`${API_ENDPOINTS.ORGANIZATIONS_SUBDOMAIN}/${subdomain}${API_ENDPOINTS.ORGANIZATIONS_BRANDING}`);
  }

  /**
   * Get organization contact information (PUBLIC)
   */
  async getContact(subdomain) {
    return this.client.get(`${API_ENDPOINTS.ORGANIZATIONS_SUBDOMAIN}/${subdomain}${API_ENDPOINTS.ORGANIZATIONS_CONTACT}`);
  }

  /**
   * Check if organization has specific feature enabled (PUBLIC)
   */
  async checkFeature(subdomain, feature) {
    return this.client.get(`${API_ENDPOINTS.ORGANIZATIONS_SUBDOMAIN}/${subdomain}${API_ENDPOINTS.ORGANIZATIONS_FEATURES}/${feature}`);
  }

  /**
   * Get organization settings (PUBLIC)
   */
  async getSettings(subdomain) {
    return this.client.get(`${API_ENDPOINTS.ORGANIZATIONS_SUBDOMAIN}/${subdomain}/settings`);
  }

  /**
   * Get paginated results (PUBLIC)
   */
  async getPaginated(page = 1, limit = 10, filters = {}) {
    const params = {
      page,
      limit,
      ...filters
    };
    return this.client.get(this.path, params);
  }

  /**
   * Search organizations (PUBLIC)
   */
  async search(query, filters = {}) {
    const params = {
      search: query,
      ...filters
    };
    return this.client.get(this.path, params);
  }

  // NOTE: The following methods are removed as they require authentication:
  // - create() - requires write permission
  // - update() - requires write permission
  // - patch() - requires write permission
  // - delete() - requires write permission
  // - createOrUpdateBySubdomain() - requires write permission
  // - initializeAll() - requires authentication (requireAuth: true)
  // - updateBranding() - requires write permission
  // - updateContact() - requires write permission
  // - enableFeature() - requires write permission
  // - disableFeature() - requires write permission
  // - updateSettings() - requires write permission
}